/*
 * Tooltip Module
 *
 * Description:
 * This modules handles events related to tooltip and places tooltip dynamically
 *
 * Purpose: 
 * This module is needed at various places to inform the user
 * 
 * Inputs
 * 
 * Outputs
 *
 * @authors: Chiran Doshi and Elton Jain
 */

define('Tooltip',['jquery', 'UI', 'JSTemplate', 'Config'], function($, UI, template, Config) {

    'use strict';

    var arrowHeight = 10,

        /**
         * [_determineDirection function determines the where exactly to place the tooltip dynamically]
         *
         * @param  Array base [element on which mouse was clicked]
         *
         * @return Object      [direction, inner/outer where tooltip is placed]
         */
        
        _determineDirection = function(base) {
            var totalHeight = window.innerHeight,
                totalWidth = window.innerWidth,
                elPosition = base.offset(),
                emptySpace = [elPosition.top - $(window).scrollTop(), // Top
                    totalWidth - elPosition.left - base.width(), // Right
                    totalHeight - elPosition.top + $(window).scrollTop() - base.height(), // Bottom
                    elPosition.left
                ],
                placement = {},
                index = emptySpace.indexOf(Math.max.apply(null, emptySpace)) + 1; // Determine which direction has maximum available space

            if (index === 1) {
                placement.direction = '-arr-t';
                if (emptySpace[1] >= emptySpace[3]) {
                    placement.direction += 'r';
                } else {
                    placement.direction += 'l';
                }
            } else if (index === 2) {
                placement.direction = '-arr-right';
            } else if (index === 3) {
                placement.direction = '-arr-b';
                if (emptySpace[1] >= emptySpace[3]) {
                    placement.direction += 'l';
                } else {
                    placement.direction += 'r';
                }
            } else if (index === 4) {
                placement.direction = '-arr-left';
            }

            placement.emptySpace = emptySpace;

            return placement;
        },

        /**
         * [displayTooltip function displays the requried tooltip]
         * Author: Chiran Doshi
         *
         * @param  Object base [Element over which tooltip is to be displayed]
         *
         */
        displayTooltip = function(base) {

            var $elTooltipContainer = $('#tooltipContainer');

            UI.$b.addClass('noscroll');

            if ($('.tooltip').length > 0) {
                $('.tooltip').remove();
            }

            var placement = _determineDirection(base),
                html = template('tplTooltip', {
                    props: placement,
                    data: base.data('tooltip-fields'),
                    langs: Config.get('lang')
                }),
                elTooltip,
                $tooltip = $(html);

            if(!$elTooltipContainer.length) {
                $elTooltipContainer = $('<div/>').attr('id', 'tooltipContainer').appendTo(UI.$b);
            }
            
            $tooltip.appendTo($elTooltipContainer);


            if (placement.direction === '-arr-left') {
                $tooltip.css('top', (base.offset().top + (base.height() - $tooltip.height()) / 2) + 'px');
                $tooltip.css('left', (base.offset().left - arrowHeight*3  - $tooltip.width() + 'px'));
            } else if (placement.direction === '-arr-right') {
                $tooltip.css('top', (base.offset().top + (base.height() - $tooltip.height()) / 2) + 'px');
                $tooltip.css('left', base.offset().left + base.width() + arrowHeight + 'px');
            } else if (/-arr-t/.test(placement.direction)) {
                $tooltip.css('top', (base.offset().top - $tooltip.height() - arrowHeight) + 'px');
                $tooltip.css('left', (base.offset().left + base.width() - arrowHeight - $tooltip.width()) + 'px');
            } else if (placement.direction === '-arr-br') {
                $tooltip.css('top', (base.offset().top + base.height() + arrowHeight) + 'px');
                $tooltip.css('left', (base.offset().left + base.width() - arrowHeight - $tooltip.width()) + 'px');
            } else if(placement.direction === '-arr-bl') {
                $tooltip.css('top', (base.offset().top + base.height() + arrowHeight) + 'px');
                $tooltip.css('left', base.offset().left + 2*arrowHeight + 'px');
            }

        },
         /**
         * [_bindEvents function binds required events to tooltip and elements that require tooltip to be shown]
         *
         */
        _bindEvents = function() {


            UI.$b.on('click', '[data-tooltip="true"]', function(ev) {
                displayTooltip($(this));
            });

            UI.$b.on('click', function(e) {
                $('.tooltip').each(function() {
                    if (!$(this).is(e.target) && $(e.target).closest("[data-tooltip]").attr("data-tooltip") === undefined) {
                        $(this).fadeOut('fast', function() {
                            $(this).remove();
                            $('#tooltipContainer').remove();
                            UI.$b.removeClass('noscroll');
                        });
                    }
                });

                if($(e.target).hasClass('suggest-tooltip-parent-search')) {
                    $(e.target).addClass('hidden');
                }
            });
        },

        init = function(options) {
            _bindEvents();
        };

    return {
        init: init,
        displayTooltip: displayTooltip
    }

});
